//
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { UPDATE_CLIENT_BANK, UPDATE_EMPPARTNER_DETAILS, UPDATE_Login_SEARCH, UPDATE_MULTIDOCS, UPDATE_ORDER_DECLARATIONS, UPDATE_ORDER_DETAILS, UPDATE_ORDER_LIST, UPDATE_ORDERS, UPDATE_SELECTED_SEARCH, UPDATE_VALIDATE_FORM, } from "../actions/PurchaseAction";
var initialState = {
    orders: null,
    orderList: null,
    validateForm: null,
    clientBank: null,
    docs: null,
    orderDeclarations: null,
    empPartnerDetails: null,
    orderDetails: null,
    selectedSearch: null,
    multidocs: null,
    loginSearch: null,
};
var purchaseReducer = function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case UPDATE_ORDERS:
            return __assign(__assign({}, state), { orders: action.payload.orders });
        case UPDATE_VALIDATE_FORM:
            return __assign(__assign({}, state), { validateForm: action.payload.validateForm });
        case UPDATE_CLIENT_BANK:
            return __assign(__assign({}, state), { clientBank: action.payload.clientBank });
        case UPDATE_ORDER_DETAILS:
            return __assign(__assign({}, state), { orderDetails: action.payload.orderDetails });
        case UPDATE_Login_SEARCH:
            return __assign(__assign({}, state), { loginSearch: action.payload.loginSearch });
        case UPDATE_EMPPARTNER_DETAILS:
            return __assign(__assign({}, state), { empPartnerDetails: action.payload.empPartnerDetails });
        case UPDATE_ORDER_DECLARATIONS:
            return __assign(__assign({}, state), { orderDeclarations: action.payload.orderDeclarations });
        case UPDATE_ORDER_LIST:
            return __assign(__assign({}, state), { orderList: action.payload.orderList });
        case UPDATE_SELECTED_SEARCH:
            return __assign(__assign({}, state), { selectedSearch: action.payload.selectedSearch });
        case UPDATE_MULTIDOCS:
            return __assign(__assign({}, state), { multidocs: action.payload.multidocs });
        default:
            return state;
    }
};
export default purchaseReducer;
